import { Client } from "@core/Client";
import { Assets } from "@core/GUI/Utils/Assets";
import { Constants, effectsVolume } from "@core/Utils/Constants";
import { numToColor } from "@core/Utils/HelperFunction";

export class WinNumbers extends Phaser.GameObjects.Container {
    protected winNumberAtlas: string;
    protected numberNamingPrefix: string;
    protected imageMaskName;
    protected playedMarker;
    protected singleZeroName: string;
    protected doubleZeroName: string;
    protected extendedBackgroundConfig;
    protected extendedDivider;
    protected openExtensionButton: Phaser.GameObjects.Rectangle;
    protected extended: boolean = false;//opens the scrollable extension showing all history numbers
    protected canToggle: boolean = true;
    protected extendedContainer: Phaser.GameObjects.Container;
    protected extendedBackground: RexPlugins.GameObjects.NinePatch;
    protected padding: number = 0;
    protected numberOfAllExpandedLines: number = 0;
    protected maxExtendedHeightInLines = 6;
    protected imageMask: Phaser.GameObjects.Image;
    protected graphics: Phaser.GameObjects.Graphics;

    protected history: Array<number[]>;
    protected images: Array<Phaser.GameObjects.Image>;
    protected playedMarkers: Map<Phaser.GameObjects.Image, Phaser.GameObjects.Image>; // key = linked image , value = played marker

    protected expanderSlider: Phaser.GameObjects.Image;
    protected expanderValue: number = 0;
    protected backgroundDividers: Array<Phaser.GameObjects.Image> = new Array<Phaser.GameObjects.Image>();
    protected dragging: { pointer: Phaser.Input.Pointer, dragging: boolean } = { pointer: undefined, dragging: false };
    protected canToggleTimeout;

    constructor(scene: Phaser.Scene) {
        super(scene);
        this.setAssetNaming();

        this.history = new Array<number[]>();
        this.images = new Array<Phaser.GameObjects.Image>();
        this.playedMarkers = new Map<Phaser.GameObjects.Image, Phaser.GameObjects.Image>();

        Client.game.events.on(Constants.EVENTS.HISTORY_UPDATE, (numbers: number[][]) => { this.SetWinNumbers(numbers); }, this);
        Client.game.events.on(Constants.EVENTS.HISTORY_UPDATE_NUMBER, (num: number[]) => { this.NewWinningNumber(num); }, this);
        Client.game.events.on(Constants.EVENTS.HISTORY_SAVED, (gameID: number) => { this.UpdateLastInteractible(gameID, true); }, this);

        if (Client.logic.currentGameState.HistoryNumbers)
            this.SetWinNumbers(Client.logic.currentGameState.HistoryNumbers);

        this.extendedBackground = new RexPlugins.GameObjects.NinePatch(scene, 0, 0, 100, 100, this.extendedBackgroundConfig[0], this.extendedBackgroundConfig[1], this.extendedBackgroundConfig[2], this.extendedBackgroundConfig[3], this.extendedBackgroundConfig[4]);
        this.extendedBackground.setOrigin(0.5, 0);
        this.extendedBackground.setInteractive();
        this.extendedBackground.on("pointerdown", (pointer: any, x: number, y: number, phaserPointer: any) => {
            phaserPointer.stopPropagation();
            this.dragging.pointer = pointer;
            this.dragging.dragging = true;
        });
        this.extendedBackground.on("pointermove", (pointer: Phaser.Input.Pointer, localX: number, localY: number, event: Phaser.Types.Input.EventData) => {
            event.stopPropagation();
            if (this.expanderSlider.visible && this.dragging.dragging && !this.expanderSlider.slider.isDragging) {
                let p1 = { x: this.dragging.pointer.downX, y: this.dragging.pointer.downY }
                let p2 = { x: pointer.x, y: pointer.y }
                let distance = Phaser.Math.Distance.BetweenPoints(p1, p2)

                if (this.dragging.pointer.downY > pointer.y && distance > 5) {
                    if (this.expanderSlider.slider.value <= 0.98)
                        this.expanderSlider.slider.value += 0.02;
                    this.dragging.pointer.downY = pointer.y
                }
                else if (this.dragging.pointer.downY < pointer.y && distance > 5) {
                    if (this.expanderSlider.slider.value >= 0.02)
                        this.expanderSlider.slider.value -= 0.02;
                    this.dragging.pointer.downY = pointer.y
                }
            }
        })
        this.extendedBackground.on("pointerout", () => {
            this.dragging.dragging = false;
            this.runTimeout(250);
        })
        this.extendedBackground.on("pointerup", (pointer: any, x: number, y: number, phaserPointer: any) => {
            phaserPointer.stopPropagation();
            this.dragging.dragging = false;
        })
        this.add(this.extendedBackground);
        this.extendedBackground.visible = this.extended;

        this.openExtensionButton = new Phaser.GameObjects.Rectangle(this.scene, 0, 0, 10, 10, 0, 0);
        this.openExtensionButton.setInteractive();
        this.openExtensionButton.on("pointerup", (pointer: Phaser.Input.Pointer, localX: number, localY: number, event: Phaser.Types.Input.EventData) => {
            event.stopPropagation();
            if (!this.extended && this.canToggle) {
                this.toggleExpansion();
            }
        });
        this.openExtensionButton.setOrigin(1, 0);
        this.add(this.openExtensionButton);

        this.extendedContainer = new Phaser.GameObjects.Container(scene, 0, 0);
        this.add(this.extendedContainer);

        this.graphics = new Phaser.GameObjects.Graphics(scene);
        this.add(this.graphics);

        this.expanderSlider = new Phaser.GameObjects.Image(scene, 0, 0, Constants.SPRITESHEET_MENU, "Menu_SliderImage.png");
        this.expanderSlider.setOrigin(0.5);
        this.expanderSlider.slider = this.scene.plugins.get('sliderplugin').add(this.expanderSlider, {
            endPoints: [{
                x: this.x - 200,
                y: this.y
            },
            {
                x: this.x + 200,
                y: this.y
            }
            ],
            value: this.expanderValue
        });
        this.expanderSlider.slider.on('valuechange', function (newValue, prevValue) {
            this.extendedContainer.y = 0 - ((this.numberOfAllExpandedLines - this.maxExtendedHeightInLines) * (this.height + this.padding * 4)) * newValue;
        }.bind(this));
        this.add(this.expanderSlider);

        this.imageMask = new Phaser.GameObjects.Image(this.scene, 0, 0, this.imageMaskName[0], this.imageMaskName[1]);
        this.imageMask.setOrigin(0);

        this.scene.input.on('pointerdown', function (pointer: any, x: number, y: number, phaserPointer: any) {
            if (this.extended && !this.dragging.dragging && this.canToggle) {
                this.toggleExpansion(true);
            }
        }.bind(this));

        this.scene.input.on('pointerup', function (pointer: any, x: number, y: number, phaserPointer: any) {
            if (this.extended && !this.dragging.dragging && this.canToggle) {
                this.toggleExpansion(true);
            }
        }.bind(this));
    }

    protected toggleExpansion(closeOnly: boolean = false): void {
        if (closeOnly)
            this.extended = false;
        else
            this.extended = !this.extended;

        this.scene.sound.play(Constants.SOUNDS.FINANCIALS_CLICK, { volume: 0.25 * effectsVolume });
        Client.logic.lockAnimations = this.extended;
        Client.logic.lockBetting = this.extended;
        this.extendedBackground.visible = this.extended;
        this.UpdatePosition(this.width, this.height);
        this.runTimeout(500);
    }

    private runTimeout(timeToRun: number): void {
        this.canToggle = false;
        clearTimeout(this.canToggleTimeout);
        this.canToggleTimeout = setTimeout(() => { this.canToggle = true; }, timeToRun);
    }

    //to support extending roulette skins having separate atlas structure, needs a big rewrite with how "assets" class works
    protected setAssetNaming(): void {
        this.winNumberAtlas = Constants.SPRITESHEET;
        this.numberNamingPrefix = "board_button_";
        this.singleZeroName = Assets.WinNumberHistory.SingleZeroTexture;
        this.doubleZeroName = Assets.WinNumberHistory.DoubleZeroTexture;
        this.extendedBackgroundConfig = [Constants.SPRITESHEET_MENU, "MenuBackground.png", [16, undefined, 16], [16, undefined, 16], { edge: 'scale', internal: 'scale' }];
        this.extendedDivider = null;
        this.imageMaskName = [Constants.SPRITESHEET_MENU, "winnumberhistorymask.png"];
        this.playedMarker = ["historyMisc","historyMarker.png"];
    }

    public UpdatePosition(width, height): void {
        if (!this.extendedContainer || height < 1 || width < 1)
            return;

        this.extendedContainer.setPosition(0, 0);
        this.extendedContainer.setVisible(this.extended);
        this.expanderSlider.setVisible(false);
        this.expanderSlider.slider.value = 0;
        this.graphics.setVisible(false);

        this.width = width;
        this.height = height;//our height are max width for our images since they are cubes

        let firstNumberSize: number = height * 0.8;
        let bump: number = firstNumberSize / 8;
        this.padding = firstNumberSize / 20;
        let otherNumberSize: number = firstNumberSize - bump;//other numbers are a tad smaller
        let numberOfRenderedNumbers: number = Math.floor( (width - (otherNumberSize / 2 + firstNumberSize + 4 * this.padding)) / (otherNumberSize + this.padding) - 1);

        this.backgroundDividers.forEach(element => {
            element.visible = this.extended;
        });
        this.numberOfAllExpandedLines = 0;
        for (let i: number = 0; i < this.images.length; i++) {
            if (i < numberOfRenderedNumbers) {
                if (i == 0) {
                    this.images[i].setDisplaySize(firstNumberSize, firstNumberSize);
                    this.images[i].setPosition(firstNumberSize / 1.5, height / 2);
                }
                else {
                    this.images[i].setDisplaySize(otherNumberSize, otherNumberSize);
                    this.images[i].setPosition(firstNumberSize + this.padding * 5 + ((otherNumberSize + this.padding) * i), height / 2);
                    switch (numToColor(this.history[i][1])) {
                        case Constants.COLORS.RED:
                            this.images[i].y -= bump / 2;
                            break;
                        case Constants.COLORS.BLACK:
                            this.images[i].y += bump / 2;
                            break;
                        default:
                            break;
                    }
                }
            }
            else {
                //if too big for normal history bar, move to extended container
                this.remove(this.images[i], false);
                this.extendedContainer.add(this.images[i]);

                this.numberOfAllExpandedLines = Math.floor(i / numberOfRenderedNumbers);

                if (this.extendedDivider != null && this.numberOfAllExpandedLines != NaN && this.numberOfAllExpandedLines > 1) {
                    let newPos = height - otherNumberSize / 2 + ((height + this.padding * 2) * this.numberOfAllExpandedLines);
                    if (this.backgroundDividers[this.numberOfAllExpandedLines - 2] != null) {
                        this.backgroundDividers[this.numberOfAllExpandedLines - 2].setDisplaySize(width - firstNumberSize * 3, this.backgroundDividers[this.numberOfAllExpandedLines - 2].height);
                        this.backgroundDividers[this.numberOfAllExpandedLines - 2].setScale(Math.min(this.backgroundDividers[this.numberOfAllExpandedLines - 2].scaleX, this.backgroundDividers[this.numberOfAllExpandedLines - 2].scaleY));
                        this.backgroundDividers[this.numberOfAllExpandedLines - 2].setPosition(width / 2, height - otherNumberSize * 1.25 + ((height + this.padding * 2) * this.numberOfAllExpandedLines));
                    }
                    else {
                        let divider = new Phaser.GameObjects.Image(this.scene, 0, 0, this.extendedDivider[0], this.extendedDivider[1]).setOrigin(0.5);
                        divider.setDisplaySize(width - firstNumberSize * 3, divider.height);
                        divider.setScale(Math.min(divider.scaleX, divider.scaleY));
                        divider.setPosition(width / 2, height - otherNumberSize * 1.25 + ((height + this.padding * 2) * this.numberOfAllExpandedLines));
                        this.extendedContainer.add(divider);
                        this.backgroundDividers.push(divider);
                    }
                }
                let floor = Math.min(Math.floor(i % numberOfRenderedNumbers));

                this.images[i].setDisplaySize(otherNumberSize, otherNumberSize);
                this.images[i].setPosition(firstNumberSize + this.padding * 5 + ((otherNumberSize + this.padding) * floor), height - otherNumberSize / 2 + ((height + this.padding * 2) * this.numberOfAllExpandedLines));
                switch (numToColor(this.history[i][1])) {
                    case Constants.COLORS.RED:
                        this.images[i].y -= bump / 2;
                        break;
                    case Constants.COLORS.BLACK:
                        this.images[i].y += bump / 2;
                        break;
                    default:
                        break;
                }
            }
        }

        if (this.openExtensionButton && this.extendedBackground && this.imageMask) {
            this.openExtensionButton.setDisplaySize(firstNumberSize, firstNumberSize);
            this.openExtensionButton.setPosition(width, 0);

            this.extendedBackground.setPosition(width / 2, firstNumberSize * 1.2);

            let heightForExtendedBg: number = (height + this.padding * 2) * (Math.min(this.maxExtendedHeightInLines, this.numberOfAllExpandedLines) + 0.5);

            if (heightForExtendedBg > 1)
                this.extendedBackground.setSize(width, heightForExtendedBg);


            if (this.extendedContainer.mask)
                this.extendedContainer.clearMask(true);

            if (this.extended && this.numberOfAllExpandedLines >= this.maxExtendedHeightInLines) {

                let sliderStartPos = height * 2;
                let sliderEndPos = this.extendedBackground.displayHeight;

                this.expanderSlider.setDisplaySize(height * 0.7, height * 0.7);
                this.expanderSlider.setPosition(width - height * 0.7, sliderStartPos + (sliderEndPos - sliderStartPos) * this.expanderSlider.slider.value);
                this.expanderSlider.slider.endPoints = [{
                    x: width - height * 0.7,
                    y: sliderStartPos
                },
                {
                    x: width - height * 0.7,
                    y: sliderEndPos
                }];

                this.graphics.clear();
                this.graphics.lineStyle(3, 0xffffff, 1).strokePoints(this.expanderSlider.slider.endPoints);

                this.expanderSlider.setVisible(true);
                this.graphics.setVisible(true);

                this.bringToTop(this.imageMask);
                this.imageMask.setDisplaySize(this.scene.scale.width, this.extendedBackground.displayHeight);
                this.imageMask.x = this.getWorldTransformMatrix().tx;
                this.imageMask.y = this.y + height;

                let actualMask = new Phaser.Display.Masks.BitmapMask(this.scene, this.imageMask);
                this.extendedContainer.mask = actualMask;
            }
        }

        this.playedMarkers.forEach((value, key) => {

            if (this.extendedContainer && this.extendedContainer.getIndex(key) != -1) {
                this.remove(value);
                this.extendedContainer.add(value);
            }

            value.setPosition(key.x, key.y);
            value.displayWidth = key.displayWidth;
            value.displayHeight = key.displayHeight;
            value.visible = key.visible;
            value.originX = key.originX;
            value.originY = key.originY;
            value.z = key.z;
        });
    }

    public SetWinNumbers(numbers: number[][]): void {
        //clean all numbers and images
        this.history = new Array<number[]>();
        this.removeAll(true);
        this.images = new Array<Phaser.GameObjects.Image>();

        for (let index = 0; index < numbers.length; index++) {
            this.addWinNumber(numbers[index], false);
        }

        this.UpdatePosition(this.width, this.height);

        this.backgroundDividers.forEach(element => {
            element.destroy();
        });
        this.backgroundDividers = new Array<Phaser.GameObjects.Image>();
    }

    private NewWinningNumber(num: number[]): void {
        if (num[1] < 0)
            return;

        this.addWinNumber(num, true);
    }

    public addWinNumber(winNumber: number[], update: boolean = false): void {
        if (winNumber[1] < 0)
            return;

        this.history.unshift(winNumber);

        let img: Phaser.GameObjects.Image;
        switch (winNumber[1]) {
            case 0:
                img = new Phaser.GameObjects.Image(this.scene, 0, 0, this.winNumberAtlas, this.singleZeroName);
                break;
            case 37:
                img = new Phaser.GameObjects.Image(this.scene, 0, 0, this.winNumberAtlas, this.doubleZeroName);
                break;
            default:
                img = new Phaser.GameObjects.Image(this.scene, 0, 0, this.winNumberAtlas, this.numberNamingPrefix + winNumber[1] + ".png");
                break;
        }

        img.setOrigin(0.5);
        this.images.unshift(img);
        this.add(img);

        while (this.history.length > Client.logic.setup.MaxHistorySize) {
            let num = this.history.pop();

            //remove the last image from array of images
            let removedImage = this.images.pop();
            
            //remove it from played markers if it was there
            if (this.playedMarkers.has(removedImage)) {
                let marker = this.playedMarkers.get(removedImage);
                this.extendedContainer.remove(marker,true);
                this.playedMarkers.delete(removedImage);
            }
            //remove it from the container
            this.extendedContainer.remove(removedImage,true);
        }
        
        if(Client.logic.isGameInHistory(winNumber[0]) != -1)
        {
            this.UpdateLastInteractible(winNumber[0]);
        }

        if (update)
            this.UpdatePosition(this.width, this.height);
    }

    public UpdateLastInteractible(gameID:number, update = false):void {
        if (!this.images[0])
            return;

        // create marker that this game was played
        let playedImg = new Phaser.GameObjects.Image(this.scene, 0, 0,  this.playedMarker[0], this.playedMarker[1]);

        if (!this.extendedContainer || this.extendedContainer.getIndex(this.images[0]) == -1)
            this.add(playedImg);
        else
            this.extendedContainer.add(playedImg);

        // link it to the number image so they stay togeather , if one is deleted , make sure to remove it from playedMarkers!!
        this.playedMarkers.set(this.images[0], playedImg);
        // make img clickable, it was played , so it needs to trigger stuff now
        this.images[0].setInteractive();
        this.images[0].on("pointerup", (pointer: Phaser.Input.Pointer, localX: number, localY: number, event: Phaser.Types.Input.EventData) => {
            event.stopPropagation();
            // close win numbers
            if (this.extended) {
                this.toggleExpansion();
            }

            // open history with linked game
            Client.logic.OnHistoryButtonClicked(Client.logic.isGameInHistory(gameID));
        }, this);

        if (update)
            this.UpdatePosition(this.width, this.height);
    }
}